<template>
    <button
        class="fulltext-search-toggle-btn p-2 rounded-lg relative z-10 hover:bg-gray-100 min-[768px]:hover:bg-gray-50"
        :class="buttonClass"
        type="button"
        :aria-label="ariaLabel"
        :aria-expanded="isExpanded"
        @click.stop="$emit('toggle')"
    >
        <icon-search :class="iconClass" />
    </button>
</template>

<script setup lang="ts">
    import IconSearch from '~/components/icons/IconSearch.vue';

    defineEmits<{
        (e: 'toggle'): void;
    }>();
    
    interface FulltextSearchToggleProps {
        ariaLabel?: string;
        buttonClass?: string;
        iconClass?: string;
        isExpanded?: boolean;
    }

    withDefaults(defineProps<FulltextSearchToggleProps>(), {
        ariaLabel: 'Toggle fulltext search',
        buttonClass: '',
        iconClass: 'w-5 h-5',
        isExpanded: false
    });
</script>

<style scoped lang="scss">
    .fulltext-search-toggle-btn {
        color: var(--button-color, #3b82f6);
        transition: all 0.15s ease;
    }
</style> 
